export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 10_04.753de15f.jpg";